export const AUTH_CODES = {
  RECOVERY_LINK_EXPIRED: 'recovery-link-expired',
  VERIFICATION_LINK_EXPIRED: 'verification-link-expired',
};
